import React from 'react';
import Button from '@material-ui/core/Button';
import useZoomScale from 'hooks/useZoomScale';

const defaultWidth = 90;
const defaultHeight = 40;
const defaultFontSize = 14;
function ScaledButton({ children, ...buttonProps }) {
  const scale = Math.min(useZoomScale(), 1);
  const style = { width: defaultWidth / scale, height: defaultHeight / scale, fontSize: defaultFontSize / scale };

  return (
    <Button {...buttonProps} style={style}>{ children }</Button>
  );
}

export default ScaledButton;